/* FARREN — E-posta yazım denetimi (V434)
 *
 * NEDEN: Sitedeki tek denetim "@ var mı, . var mı" idi. Bu yüzden
 * hotmal.com / cioud.com / gmail.cm gibi tek harf hatalarıyla kaydolan
 * müşteriye bir daha HİÇBİR e-posta ulaşmıyor: kupon da, sipariş bilgisi de,
 * sepet hatırlatması da. Gerçek kayıtlarda üç örneği var, ikisi ödeme
 * adımında yazılmış (terk edilmiş sepet), biri bülten pop-up'ında.
 *
 * NE YAPAR: Müşteri alandan çıkınca — ya da göndermeye kalkınca — domaini
 * tanınan sağlayıcılarla kıyaslar; yakın ama birebir değilse alanın hemen
 * altında "Bunu mu demek istediniz: ...@hotmail.com?" önerisini gösterir.
 * Öneriye tıklamak adresi düzeltir.
 *
 * ZORLAMAZ: Bariz bozuk biçimi (@ yok, domainde nokta yok, iki @) her zaman
 * durdurur — o adres hiçbir ihtimalle doğru olamaz. Yalnızca "şüpheli yazım"
 * durumunda ilk gönderimi durdurur; müşteri aynı adresi ikinci kez
 * gönderirse geçirir. Kurumsal bir adres yanlış yere takılıp satış/kayıt
 * kaybettirmesin diye.
 *
 * Kapsam: sitedeki TÜM e-posta alanları (bülten pop-up'ı, footer bülteni,
 * sepetteki %10 kutusu, stoğa gelince haber ver, iade/sipariş takibi, üyelik).
 * Shopify'ın kendi ödeme sayfası bu betiğin ulaşamadığı tek yüzey.
 */
(function () {
  'use strict';

  // Birebir doğru bilinen adresler — bunlara asla öneri çıkmaz.
  var BILINEN = ('gmail.com googlemail.com hotmail.com hotmail.com.tr outlook.com ' +
    'outlook.com.tr live.com live.com.tr msn.com windowslive.com icloud.com me.com ' +
    'mac.com yahoo.com yahoo.com.tr ymail.com yandex.com yandex.com.tr yandex.ru ' +
    'mail.ru protonmail.com proton.me pm.me aol.com gmx.com gmx.de web.de mail.com ' +
    'email.com hotmail.fr hotmail.de hotmail.co.uk mynet.com superonline.com ' +
    'turk.net e-kolay.net ttmail.com trendyolmail.com farren.com.tr').split(' ');

  // Yazım hatasının düzeltileceği hedefler (yaygınlık sırası önemli değil).
  var HEDEF = ('gmail.com hotmail.com outlook.com icloud.com yahoo.com live.com ' +
    'windowslive.com msn.com yandex.com mail.ru protonmail.com me.com ' +
    'hotmail.com.tr yahoo.com.tr mynet.com superonline.com googlemail.com').split(' ');

  // Uzaklık hesabının yakalayamadığı, sahada görülen kalıplar.
  var SABIT = {
    'cioud.com': 'icloud.com', 'iclould.com': 'icloud.com', 'icould.com': 'icloud.com',
    'iclod.com': 'icloud.com', 'iclou.com': 'icloud.com', 'icloude.com': 'icloud.com',
    'hotmial.com': 'hotmail.com', 'hotamil.com': 'hotmail.com', 'hotmaail.com': 'hotmail.com',
    'homtail.com': 'hotmail.com', 'hotmali.com': 'hotmail.com', 'hotmeil.com': 'hotmail.com',
    'gmial.com': 'gmail.com', 'gmaail.com': 'gmail.com', 'gamil.com': 'gmail.com',
    'gmail.co.com': 'gmail.com', 'gmailc.om': 'gmail.com', 'gmaul.com': 'gmail.com',
    'yhaoo.com': 'yahoo.com', 'yahho.com': 'yahoo.com', 'yaoo.com': 'yahoo.com',
    'oulook.com': 'outlook.com', 'outllok.com': 'outlook.com', 'outlok.com': 'outlook.com',
    'windowlive.com': 'windowslive.com', 'windowslive.co': 'windowslive.com'
  };

  // Kurumsal/kurum uzantıları: sağlayıcıya benzemez, öneriye hiç sokma.
  var KURUMSAL = /\.(com|net|org|edu|gov|k12|av|bel|pol|tsk|bbs|gen|web|info|biz|name|tv)\.tr$|\.(edu|gov|mil|ac)$/;

  // Bariz yanlış üst düzey uzantılar → .com
  var TLD_HATA = { con: 1, cno: 1, cmo: 1, ocm: 1, comm: 1, cim: 1, vom: 1, xom: 1, coom: 1, cm: 1, om: 1, co: 1, c0m: 1, cok: 1, clm: 1, dom: 1 };

  function uzaklik(a, b) {
    // Damerau–Levenshtein (yer değiştirme dahil): "cioud" ↔ "icloud" gibi
    // harf sırası hatalarını da tek adım sayar.
    var m = a.length, n = b.length, i, j, d = [];
    if (!m) return n;
    if (!n) return m;
    for (i = 0; i <= m; i++) { d[i] = [i]; }
    for (j = 0; j <= n; j++) { d[0][j] = j; }
    for (i = 1; i <= m; i++) {
      for (j = 1; j <= n; j++) {
        var bedel = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
        d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + bedel);
        if (i > 1 && j > 1 && a.charAt(i - 1) === b.charAt(j - 2) && a.charAt(i - 2) === b.charAt(j - 1)) {
          d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
        }
      }
    }
    return d[m][n];
  }

  function parcala(deger) {
    var v = String(deger || '').replace(/\s+/g, '').replace(/[.,;]+$/, '');
    var k = v.lastIndexOf('@');
    if (k < 0) return { ham: v, yerel: v, alan: '' };
    return { ham: v, yerel: v.slice(0, k), alan: v.slice(k + 1).toLowerCase() };
  }

  // Hiçbir ihtimalle doğru olamayacak biçimler. Dönerse gönderim durdurulur.
  function biçimHatasi(p) {
    if (!p.ham) return '';
    var kacAt = p.ham.split('@').length - 1;
    if (kacAt === 0) return 'E-posta adresinde “@” işareti eksik. Örnek: adiniz@gmail.com';
    if (kacAt > 1) return 'E-posta adresinde tek bir “@” olmalı.';
    if (!p.yerel) return '“@” işaretinden önce adınız eksik.';
    if (!p.alan) return '“@” işaretinden sonrası eksik. Örnek: adiniz@gmail.com';
    if (p.alan.indexOf('.') < 1) return 'Adresin sonu eksik görünüyor. Örnek: ' + p.yerel + '@gmail.com';
    if (/[ığüşöçİĞÜŞÖÇ]/.test(p.ham)) return 'E-posta adresi Türkçe karakter içeremez (ı, ğ, ü, ş, ö, ç).';
    if (/\.\./.test(p.alan) || /^[.-]|[.-]$/.test(p.alan)) return 'Adresin yazımında bir hata var gibi görünüyor.';
    if (!/^[a-z0-9.-]+$/.test(p.alan)) return 'Adresin “@” sonrası geçersiz karakter içeriyor.';
    if (!/\.[a-z]{2,}$/.test(p.alan)) return 'Adresin sonu eksik görünüyor. Örnek: ' + p.yerel + '@gmail.com';
    return '';
  }

  // Yakın ama birebir değil → öneri döndürür, yoksa boş.
  function oneri(alan) {
    if (!alan || BILINEN.indexOf(alan) >= 0) return '';
    if (SABIT[alan]) return SABIT[alan];
    if (KURUMSAL.test(alan)) return '';

    // gmail.con / hotmail.cm gibi yalnız uzantısı bozuk olanlar
    var nokta = alan.lastIndexOf('.');
    if (nokta > 0) {
      var govde = alan.slice(0, nokta), uzanti = alan.slice(nokta + 1);
      if (TLD_HATA[uzanti] && HEDEF.indexOf(govde + '.com') >= 0) return govde + '.com';
      if (!uzanti && HEDEF.indexOf(govde + '.com') >= 0) return govde + '.com';
    }
    // "@gmail" gibi uzantısız yazımlar
    if (alan.indexOf('.') < 0 && HEDEF.indexOf(alan + '.com') >= 0) return alan + '.com';

    var enIyi = '', enKisa = 99;
    for (var i = 0; i < HEDEF.length; i++) {
      var d = uzaklik(alan, HEDEF[i]);
      if (d > 0 && d < enKisa) { enKisa = d; enIyi = HEDEF[i]; }
    }
    if (!enIyi) return '';
    // 1 harf hatası her zaman; 2 harf hatası yalnız yeterince uzun adreslerde
    // (kısa kurumsal adreslerde 2 harf tesadüfen tutabiliyor).
    if (enKisa === 1) return enIyi;
    if (enKisa === 2 && alan.length >= 8 && alan.charAt(0) === enIyi.charAt(0)) return enIyi;
    if (enKisa === 2 && alan.length >= 8 && uzaklik(alan.split('.')[0], enIyi.split('.')[0]) <= 2 && alan.split('.').pop() === enIyi.split('.').pop()) return enIyi;
    return '';
  }

  // ---------- arayüz ----------
  var STIL = '.frn-mailchk{margin:7px 0 0;font:400 12.5px/1.5 Manrope,-apple-system,system-ui,sans-serif;' +
    'color:#7a1f2b;display:block}' +
    '.frn-mailchk__fix{appearance:none;background:none;border:0;padding:0;margin:0;font:inherit;' +
    'color:#7a1f2b;font-weight:600;text-decoration:underline;text-underline-offset:2px;cursor:pointer}' +
    '.frn-mailchk__fix:hover{opacity:.75}';

  function stilEkle() {
    if (document.getElementById('frn-mailchk-css')) return;
    var s = document.createElement('style');
    s.id = 'frn-mailchk-css';
    s.textContent = STIL;
    (document.head || document.documentElement).appendChild(s);
  }

  // Uyarı, alana MÜMKÜN OLDUĞUNCA YAKIN durmalı; müşteri sayfanın altındaki
  // bir mesajı görmez. Ama satır flex/grid ise araya <p> koymak yerleşimi
  // bozar (pop-up formu ve sepetteki %10 kutusu böyle). O yüzden normal akışa
  // çıkana kadar yukarı tırmanıp ilk uygun kardeşin ardına yerleşiyoruz.
  function capa(input) {
    var el = input, adim = 0;
    while (el.parentElement && adim++ < 6) {
      var ust = el.parentElement, d = '';
      try { d = window.getComputedStyle(ust).display || ''; } catch (e) {}
      if (d.indexOf('flex') < 0 && d.indexOf('grid') < 0) return el;
      el = ust;
    }
    return input.closest('form') || input.parentElement || input;
  }

  function kutu(input) {
    var yer = capa(input);
    if (!yer || !yer.parentElement) return null;
    var mevcut = yer.nextElementSibling;
    if (mevcut && mevcut.classList && mevcut.classList.contains('frn-mailchk')) return mevcut;
    var p = document.createElement('p');
    p.className = 'frn-mailchk';
    p.setAttribute('role', 'status');
    yer.insertAdjacentElement('afterend', p);
    return p;
  }

  function temizle(input) {
    var yer = capa(input);
    var el = yer && yer.nextElementSibling;
    if (el && el.classList && el.classList.contains('frn-mailchk')) el.remove();
  }

  function goster(input, metin, duzeltme) {
    stilEkle();
    var p = kutu(input);
    if (!p) return;
    p.textContent = '';
    if (duzeltme) {
      p.appendChild(document.createTextNode('Bunu mu demek istediniz: '));
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'frn-mailchk__fix';
      b.textContent = duzeltme;
      b.addEventListener('click', function () {
        input.value = duzeltme;
        input.dataset.frnMailSon = '';
        try {
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        } catch (e) {}
        temizle(input);
        input.focus();
      });
      p.appendChild(b);
      // Bölünmez boşluk: dar ekranda soru işareti tek başına alt satıra
      // düşüyordu (375px'de adres uzun olduğu için sarma noktası oraya geliyor).
      p.appendChild(document.createTextNode('\u00A0?'));
    } else {
      p.textContent = metin;
    }
  }

  // Alanın durumu: {sert:'mesaj'|'', oneri:'tam@adres'|''}
  function denetle(input) {
    var p = parcala(input.value);
    if (!p.ham) return { sert: '', oneri: '' };
    var sert = biçimHatasi(p);
    if (sert) return { sert: sert, oneri: '' };
    var yeni = oneri(p.alan);
    return { sert: '', oneri: yeni ? p.yerel + '@' + yeni : '' };
  }

  function epostaAlaniMi(el) {
    if (!el || el.tagName !== 'INPUT') return false;
    if (el.type === 'email') return true;
    var ad = (el.name || '').toLowerCase();
    return ad === 'email' || ad === 'contact[email]' || ad === 'customer[email]';
  }

  function alanBul(kapsayici) {
    if (!kapsayici || !kapsayici.querySelectorAll) return null;
    var hepsi = kapsayici.querySelectorAll('input'), ilk = null;
    for (var i = 0; i < hepsi.length; i++) {
      if (!epostaAlaniMi(hepsi[i])) continue;
      if (!ilk) ilk = hepsi[i];
      // Aynı kapsayıcıda birden çok alan varsa ekranda görüneni seç;
      // hiçbiri ölçülemiyorsa ilk eşleşmeye düş (gizli alan sanıp geçme).
      if (hepsi[i].getClientRects && hepsi[i].getClientRects().length) return hepsi[i];
    }
    return ilk;
  }

  // Gönderim engellenmeli mi? (true → dur)
  function engelle(input) {
    var d = denetle(input);
    if (d.sert) { goster(input, d.sert, ''); input.focus(); return true; }
    if (d.oneri) {
      // Şüpheli yazımda yalnız ilk denemeyi durdur: müşteri aynı adresi
      // bilerek ikinci kez gönderiyorsa yolunu kesme.
      if (input.dataset.frnMailSon === input.value.trim()) { temizle(input); return false; }
      input.dataset.frnMailSon = input.value.trim();
      goster(input, '', d.oneri);
      input.focus();
      return true;
    }
    temizle(input);
    return false;
  }

  // ---------- olaylar (sonradan DOM'a giren pop-up da kapsansın diye devretme) ----------
  document.addEventListener('focusout', function (e) {
    if (!epostaAlaniMi(e.target)) return;
    try {
      var d = denetle(e.target);
      if (d.sert) goster(e.target, d.sert, '');
      else if (d.oneri) goster(e.target, '', d.oneri);
      else temizle(e.target);
    } catch (err) {}
  }, true);

  document.addEventListener('input', function (e) {
    if (!epostaAlaniMi(e.target)) return;
    temizle(e.target); // yazarken uyarı yüzüne bakmasın, çıkışta yeniden bakılır
  }, true);

  // Form gönderimi — tema kendi dinleyicisine ulaşmadan önce (yakalama evresi).
  document.addEventListener('submit', function (e) {
    try {
      var input = alanBul(e.target);
      if (!input || !input.value.trim()) return;
      if (engelle(input)) { e.preventDefault(); e.stopPropagation(); }
    } catch (err) {}
  }, true);

  // Bazı kutular <form> kullanmıyor, düğmeye click ile gönderiyor
  // (sepetteki %10 kutusu). Yalnız e-posta alanıyla AYNI satırdaki düğmeyi
  // dinle; kapatma/atlama düğmelerine dokunma.
  document.addEventListener('click', function (e) {
    try {
      var btn = e.target.closest && e.target.closest('button,input[type=submit]');
      if (!btn || btn.closest('form')) return; // formlu hâli submit'te ele alınıyor
      if (btn.hasAttribute('data-np-close') || btn.hasAttribute('data-np-skip')) return;
      var satir = btn.parentElement;
      var input = alanBul(satir) || alanBul(satir && satir.parentElement);
      if (!input || !input.value.trim()) return;
      if (engelle(input)) { e.preventDefault(); e.stopPropagation(); }
    } catch (err) {}
  }, true);
})();
